// client/src/components/influencer/project/modals/ContractRequestModal.js
import React from 'react';

function ContractRequestModal({ open, onClose, onNext, project }) {
  if (!open || !project) return null;

  return (
    <div className="influencer-contract-modal">
      <div className="influencer-contract-modal__content" style={{ maxWidth: 600, maxHeight: '80vh', overflowY: 'auto', position: 'relative' }} onClick={(e) => e.stopPropagation()}>
        {/* X 버튼 */}
        <button 
          className="influencer-contract-modal__close" 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '32px',
            height: '32px',
            padding: '0',
            margin: '0',
            border: 'none',
            background: '#f3f4f6',
            borderRadius: '50%',
            fontSize: '26px',
            lineHeight: '0',
            cursor: 'pointer',
            color: '#6b7280',
            transition: 'all 0.2s',
            fontFamily: 'Arial, sans-serif',
            fontWeight: '300'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#e5e7eb';
            e.target.style.color = '#374151';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#f3f4f6';
            e.target.style.color = '#6b7280';
          }}
        >
          <span style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'block'
          }}>
            ×
          </span>
        </button>

        {/* 제목 */}
        <h2 className="influencer-contract-modal__title" style={{ marginBottom: 24 }}>광고주의 추가 요청 사항</h2>
        
        {/* 광고주 요청사항 */}
        <div className="influencer-contract-modal__summary" style={{ marginBottom: 24, whiteSpace: 'pre-wrap' }}>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12, color: '#374151' }}>📝 광고주의 추가 요청 사항</div>
          <div style={{ padding: 16, background: '#f9fafb', borderRadius: 8, fontSize: 14, lineHeight: 1.6, color: '#4b5563' }}>
            {project.marketerRequest || '(요청사항 없음)'}
          </div>
        </div>

        {/* 트래킹 URL (구매당 리워드인 경우) */}
        {project.trackingUrl && (
          <div className="influencer-contract-modal__summary" style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12, color: '#374151' }}>🔗 추적 URL</div>
            <div style={{ padding: 12, background: '#eff6ff', border: '1px solid #3b82f6', borderRadius: 6, fontSize: 13, color: '#1e40af', wordBreak: 'break-all', fontFamily: 'monospace' }}>
              {project.trackingUrl}
            </div>
            <div style={{ marginTop: 8, fontSize: 12, color: '#ef4444' }}>
              ⚠️ 이 URL을 통해 구매가 발생해야 추가 리워드가 지급됩니다.
            </div>
          </div>
        )}

        {/* 광고주 담당자 정보 */}
        {project.manager && (
          <div className="influencer-contract-modal__summary" style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12, color: '#374151' }}>👤 광고주 담당자 정보</div>
            <div style={{ padding: 16, background: '#f9fafb', borderRadius: 8, fontSize: 14, color: '#4b5563', lineHeight: 1.8 }}>
              {project.manager.name && <div>이름: {project.manager.name}</div>}
              {project.manager.phone && <div>연락처: {project.manager.phone}</div>}
              {project.manager.email && <div>이메일: {project.manager.email}</div>}
            </div>
          </div>
        )}

        {/* 확인 버튼 */}
        <button className="influencer-contract-modal__button influencer-contract-modal__button--confirm" style={{ width: '100%', marginTop: 8 }} onClick={onNext}>
          모든 내용을 읽었으며, 동의합니다.
        </button>
      </div>
    </div>
  );
}

export default ContractRequestModal;

